import React, { useState } from "react";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      alert("كلمة المرور غير متطابقة");
      return;
    }

    try {
      const res = await fetch(
        "http://localhost/my_projects/my_app/backend/register.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await res.json();
      alert(data.message);
    } catch (err) {
      console.error(err);
      alert("فشل الاتصال بالسيرفر");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f4f3ef",
        fontFamily: "'Alan Sans', sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "32px",
          borderRadius: "8px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: "400px",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "24px", color: "#0a342e" }}>إنشاء حساب</h2>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <input
            type="email"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "1rem",
              outline: "none",
            }}
          />
          <input
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "1rem",
              outline: "none",
            }}
          />
          <input
            type="password"
            placeholder="تأكيد كلمة المرور"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={{
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "1rem",
              outline: "none",
            }}
          />

          <button
            type="submit"
            style={{
              padding: "12px",
              background: "#0a342e",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.background = "#1d3d34")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.background = "#0a342e")
            }
          >
            تسجيل
          </button>
        </form>
      </div>
    </div>
  );
}

export default SignUp;
